import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface CurrencyIdFormFieldProps {
  currencies?: { label: string; value: number }[]
  loading?: boolean
  disabled?: boolean
}

export const CurrencyIdFormField: React.FC<CurrencyIdFormFieldProps> = ({
  currencies,
  loading,
  disabled,
}) => {
  const { control, setValue } = useFormContext<{ currency_id: number }>()
  return (
    <FormField
      name="currency_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Currency</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              disabled={disabled}
              loading={loading}
              value={field.value?.toString()}
              options={currencies?.map(({ label, value }) => ({ label, value: value?.toString() }))}
              setValue={(val) =>
                setValue('currency_id', parseInt(val), {
                  shouldValidate: true,
                })
              }
              placeholder={'Select an Currency'}
            />
          </FormItem>
        )
      }}
    />
  )
}
